export default __webpack_public_path__ + "static/media/Felsenpinguin.4ff990f4.jpg";